import { render } from "./DocumentMinusIcon.vue?vue&type=template&id=0c55a66a"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__